module.exports = __webpack_public_path__ + "static/WS_appflows_virtual_4-79052cfb273a97fb1ff8dabbcb3b076f.gif";